<template>
  <Chart :data="chartData" :options="chartOption"></Chart>
</template>

<script lang="ts">
import { PerformanceReportSummary } from "@/types";
import { ChartData, ChartOptions } from "chart.js";
import { clone, groupBy, sum } from "ramda";
import { computed, PropType, ref } from "vue";
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "PerformanceChart4",
  props: {
    summary: {
      type: Array as PropType<Array<PerformanceReportSummary>>,
      required: true,
    },
  },
  setup(props) {
    const labels = ref([
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ]);
    const seriesA = computed(() => {
      if (!props.summary) return [];
      const sortedList = clone(props.summary);

      sortedList.sort((x, y) => x.month.localeCompare(y.month));

      const value = groupBy<PerformanceReportSummary>(
        (x) => x.month,
        sortedList
      );
      return labels.value.map((k) => {
        const caseAssign = !value[k]
          ? 0
          : sum(value[k].map((x) => x.caseAssign)) /
            sum(value[k].map((x) => x.totalShipments));
        const customers = !value[k]
          ? 0
          : sum(value[k].map((x) => x.customers)) /
            sum(value[k].map((x) => x.totalShipments));
        return caseAssign / customers;
      });
    });
    // const seriesB = computed(() => {
    //   if (!props.summary) return [];
    //   const sortedList = clone(props.summary);

    //   sortedList.sort((x, y) => x.month.localeCompare(y.month));

    //   const value = groupBy<PerformanceReportSummary>(
    //     (x) => x.month,
    //     sortedList
    //   );
    //   return Object.keys(value).map((k) => {
    //     return (
    //       sum(value[k].map((x) => x.customers)) /
    //       sum(value[k].map((x) => x.totalShipments))
    //     );
    //   });
    // });
    const chartData = computed(() => {
      return {
        labels: labels.value,
        datasets: [
          {
            type: "bar",
            label: "Avg. Cases/Outlet",
            backgroundColor: "#910c29",
            data: seriesA.value,
            yAxisID: "y",
            order: 2,
          },
          // {
          //   type: "line",
          //   label: "Outlet/trip",
          //   backgroundColor: "red",
          //   data: seriesB.value,
          //   yAxisID: "y1",
          //   order: 1,
          // },
        ],
      } as ChartData;
    });

    const chartOption = computed(() => {
      return {
        responsive: true,
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "left",
          },
          // y1: {
          //   type: "linear",
          //   display: true,
          //   position: "right",
          // },
        },
        plugins: {
          datalabels: {
            anchor: "end",
            align: "start",
            color: "white",
            formatter: Math.round,
            font: {
              weight: "bold",
            },
          },
        },
      } as ChartOptions;
    });

    return { chartData, chartOption };
  },
});
</script>

<style></style>
